/**
 * Simple in-memory API response cache.
 * Caches GET responses for a configurable TTL to avoid
 * redundant requests during navigation.
 */

const cache = new Map();
const DEFAULT_TTL = 60000; // 60 seconds - prevents "connection error" on fast navigation

export const apiCache = {
  get(key) {
    const entry = cache.get(key);
    if (!entry) return null;
    if (Date.now() > entry.expiry) {
      cache.delete(key);
      return null;
    }
    return entry.data;
  },

  set(key, data, ttl = DEFAULT_TTL) {
    cache.set(key, { data, expiry: Date.now() + ttl });
    // Cleanup old entries
    if (cache.size > 100) {
      const now = Date.now();
      for (const [k, v] of cache) {
        if (now > v.expiry) cache.delete(k);
      }
    }
  },

  invalidate(pattern) {
    if (!pattern) { cache.clear(); return; }
    for (const key of cache.keys()) {
      if (key.includes(pattern)) cache.delete(key);
    }
  },

  clear() { cache.clear(); },
};

export default apiCache;
